define('plugins/musicfavourite/nls/music_guide/dialog',{
    'en-gb': {
        'upsell': {
            'heading': 'Sign in to follow presenter playlists',
            'text': 'What are your favourite presenters really listening to? <br /> See what tracks they&#39;re adding by following their personal playlists.',
            'signIn': 'Sign in',
            'signInText1': ' with your BBC iD',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'It&rsquo;s fast and free.'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit',
            'manageLink': 'Manage your presenter playlists',
            'limitHint': '(you can follow up to 12)'
        }
    },
    'cy-gb': { //WELSH
        'upsell': {
            'heading': 'Mewngofnodi i ddilyn rhestrau chwarae cyflwynwyr',
            'text': 'Beth yw dewis cerddorol eich hoff gyflwynwyr? Gallwch weld pa draciau maen nhw&#x2019;n eu hychwanegu drwy ddilyn eu rhestrau chwarae personol.',
            'signIn': 'Mewngofnodwch',
            'signInText1': ' gyda&rsqo;ch BBC iD',
            'signInText2': 'neu',
            'signInText3': 'Gofrestrwch',
            'signInText4': 'Mae&rsquo;n gyflym ac yn rhad.'
        }
    },
    'ga-gb': { //IRISH
        'upsell': {
            'heading': 'S&iacute;nigh isteach le seinnliosta&iacute; l&aacute;ithreoir&iacute; a lean&uacute;int',
            'text': 'Cad leis a bhfuil na l&aacute;ithreoir&iacute; is rogha leat ag &eacute;isteacht, i nd&aacute;ir&iacute;re? F&eacute;ach na traiceanna at&aacute; siad ag cur isteach, tr&iacute;na seinnliosta&iacute; pearsanta a lean&uacute;int.',
            'signIn': 'S&iacute;nigh isteach',
            'signInText1': ' ag baint &uacute;s&aacute;ide as do BBC iD',
            'signInText2': 'n&oacute;',
            'signInText3': 'Cl&aacute;raigh',
            'signInText4': 'T&aacute; s&eacute; simpl&iacute; agus saor.'
        }
    },
    'gd-gb': { //SCOTTISH
        'upsell': {
            'heading': 'Log a-steach is lean cl&agrave;ran-ci&ugrave;il nam preasantairean',
            'text': 'Co ris tha na preasantairean as fhe&agrave;rr leat ag &egrave;isteachd? Lean na cl&agrave;ran-ci&ugrave;il aca is faic d&egrave; na p&igrave;osan ci&ugrave;il a tha a\' nochdadh.',
            'signIn': 'Log a-steach',
            'signInText1': ' le BBC iD',
            'signInText2': 'no',
            'signInText3': 'Cl&agrave;raich',
            'signInText4': 'Tha e luath is saor agus an asgaidh.'
        }
    }
});

